import SiteHeader from './components/SiteHeader';
import Hero from './components/Hero';
import CollectionIndex from './components/CollectionIndex';
import QuickProfile from './components/QuickProfile';
import ProfileTable from './components/ProfileTable';
import IdentitySection from './components/IdentitySection';
import Timeline from './components/Timeline';
import EncyclopediaIndex from './components/EncyclopediaIndex';
import Faq from './components/Faq';
import CtaSection from './components/CtaSection';
import SiteFooter from './components/SiteFooter';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <SiteHeader />
      <main>
        <Hero />
        <CollectionIndex />
        <QuickProfile />
        <ProfileTable />
        <IdentitySection />
        <Timeline />
        <EncyclopediaIndex />
        <Faq />
        <CtaSection />
      </main>
      <SiteFooter />
    </div>
  );
}